import React from "react";
import { Carousel, Card } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "antd/dist/reset.css";
import { MostPopular } from "../utils/Images";
import useScreenWidth from "./UseScreenwidth";
import { AvatarBadge, Badge } from "@chakra-ui/react";

const SubscriptionCarousel = ({ carouselListing }) => {
    const screenWidth = useScreenWidth();
    console.log(screenWidth, "screenWidth")
    return (
        <div style={{ textAlign: "center", padding: screenWidth <= 900 ? "40px 50px" : "40px 122px" }}>
            <h2 style={{ fontWeight: "700", fontSize: "36px" }}>Affordable Plans for Every Family.</h2>
            <p style={{ color: "#848199", fontSize: "20px" }}>Start for free. Upgrade anytime to unlock more calls and features.</p>

            <Carousel
                slidesToShow={screenWidth <= 860 ? 1 : screenWidth <= 1235 ? 2 : screenWidth <= 1422 ? 3 : 4}
                slidesToScroll={1}
                prefixCls="custom-carousel"
                dots={false}
                arrows
                prevArrow={<button style={{ position: "absolute", left: "-50px", top: "50%", transform: "translateY(-50%)", background: "#fff", border: "none", cursor: "pointer" }}><LeftOutlined style={{ fontSize: "24px" }} /></button>}
                nextArrow={<button style={{ position: "absolute", right: "-50px", top: "50%", transform: "translateY(-50%)", background: "#fff", border: "none", cursor: "pointer" }}><RightOutlined style={{ fontSize: "24px" }} /></button>}
            >
                {carouselListing && carouselListing?.length > 0 && carouselListing?.map((plan, index) => (
                    <div key={index} style={{ padding: "0 10px" }}>
                        <Card
                            style={{
                                width: 292,
                                height: 385,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "0 auto",
                                borderRadius: "26px",
                                border: "none",
                                boxShadow: plan?.name == "Premium Plan" ? "0px 4px 10px rgba(0,0,0,0.1)" : "",
                                background: plan?.name == "Premium Plan" ? "#108084" : "#fff",
                                color: plan?.name == "Premium Plan" ? "#fff" : "#000",
                            }}
                        >
                            {plan.name == "Premium Plan" && (
                                <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
                                    {/* <img src={MostPopular} alt="" width={121} height={27} /> */}
                                    <Badge variant='outline' colorScheme='brand' color="white" border="1px solid" borderRadius="3xl" px={4} py={1} borderColor="white">
                                        Most Popular
                                    </Badge>
                                </div>
                            )}
                            <div style={{}}>
                                <h3 style={{ textAlign: "left", color: plan?.name == "Premium Plan" ? "#fff" : "#231D4F", fontSize: "36px" }}>${plan?.amount} <span style={{ color: plan?.name == "Premium Plan" ? "#fff" : "#848199", fontWeight: "500", fontSize: "17px" }}>/{plan?.interval}</span></h3>
                                <h4 style={{ textAlign: "left", color: plan?.name == "Premium Plan" ? "#fff" : "#231D4F", fontSize: "25px", margin: "20px 0px 71px 0px" }}>{plan?.name}</h4>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li style={{ textAlign: "left", color: plan?.name == "Premium Plan" ? "#fff" : "#848199", fontWeight: "500", fontSize: "15px" }}>✔ Includes {plan?.planServices?.noOfCalls} calls</li>
                                    <li style={{ textAlign: "left", color: plan?.name == "Premium Plan" ? "#fff" : "#848199", fontWeight: "500", fontSize: "15px" }}>✔ {plan?.planServices?.totalMinutes} minutes each call</li>
                                    <li style={{ textAlign: "left", color: plan?.name == "Premium Plan" ? "#fff" : "#848199", fontWeight: "500", fontSize: "15px" }}>✔ Pay-as-you-go applicable</li>
                                </ul>
                            </div>
                        </Card>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default SubscriptionCarousel;
